import { Button } from '@/components/ui/Button'
import { useLoadMapConfig } from '@/hooks/load/useLoadMapConfig'
import { useMobile } from '@/hooks/useMobile'
import { getMapConfig } from '@/stores/config'
import { useSelector } from '@/stores/hooks'
import { useLibmapState, useMapReady } from '@lc/libmap-react'
import { useObserve } from '@lc/libreact'
import { useState } from 'react'
import styles from './MapOptions.scss'
import { StyleSwitch } from './StyleSwitch'

export function MapOptions({
	hidden,
	setHidden,
}: {
	hidden: boolean
	setHidden: React.Dispatch<React.SetStateAction<boolean>>
}) {
	const [currentStyle, setCurrentStyle] = useState<string>('')
	useLoadMapConfig({ level: 1 })
	const mapConfig = useSelector(getMapConfig)
	const observeHidden = useObserve(hidden)
	const mapState = useLibmapState()
	const mapReady = useMapReady()
	const isMobile = useMobile()

	if (!mapConfig) return null
	if (!mapReady) return null

	return (
		<div className={styles.mapOptions}>
			<div className={styles.options}>
				<StyleSwitch
					current={currentStyle || mapConfig.styles[0].id}
					onSwitch={(id, options) => {
						if (!mapState?.map?.ready) return
						if (currentStyle === id) return
						setCurrentStyle(id)
						void (async () => {
							setHidden(true)
							await observeHidden.waitFor(true)
							if (!mapState?.map?.ready) return
							mapState.map.setOptions(options)
							setHidden(false)
						})()
					}}
				/>
				{!isMobile && (
					<>
						<Button
							rounded
							iconUrl="assets/Plus.svg"
							level="map-options-selector"
							onClick={() => {
								if (
									!mapState?.map?.ready ||
									!mapState.lib.flyTo
								)
									return
								mapState.lib.flyTo(mapState.map, {
									zoom: mapState.map.getZoom() + 1,
								})
							}}
						/>
						<Button
							rounded
							iconUrl="assets/Minus.svg"
							level="map-options-selector"
							onClick={() => {
								if (
									!mapState?.map?.ready ||
									!mapState.lib.flyTo
								)
									return
								mapState.lib.flyTo(mapState.map, {
									zoom: mapState.map.getZoom() - 1,
								})
							}}
						/>
					</>
				)}
			</div>
		</div>
	)
}
